import {Observable} from 'rxjs';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {
    Filter,
    SimpleMultiSeries,
    SimpleSeries,
    SimpleUnit,
    ThresholdStatic,
} from '@core/interfaces/system/system-common';
import {LatestModelStatus} from '@core/interfaces/live/live';

export interface VegClearanceUnits {
    lengthUnit: SimpleUnit;
    rateUnit: SimpleUnit;
}

export interface VegClearanceClearanceData {
    data: SimpleMultiSeries<Date>;
    thresholds: ThresholdStatic[];
}

export interface VegClearanceLastTrimData {
    data: SimpleSeries<Date, number>;
    thresholds: ThresholdStatic[];
}

export abstract class VegClearanceService {
    abstract getVegClearanceUnits(): Observable<VegClearanceUnits>;

    abstract getVegClearanceDatasource(id: string, filters: Filter[]): Observable<DataSource>;

    abstract getCountResults(id: string, uploadTime?: string): Observable<number>;

    abstract getVegClearanceLatestModelStatus(id: string, uploadTime?: string): Observable<LatestModelStatus>;

    abstract getVegClearanceClearanceData(id: string, uploadTime?: string): Observable<VegClearanceClearanceData>;

    abstract getVegClearanceLastTrimData(id: string, uploadTime?: string): Observable<VegClearanceLastTrimData>;
}
